import { createContext, ReactNode, useContext, useMemo } from 'react';

import type { Form } from 'types';

type Context = {
  form: Form;
};

type Props = {
  form: Form;
  children: ReactNode;
};

const FormRowContext = createContext<Context | null>(null);

export const FormRowContextProvider = ({ form, children }: Props) => {
  const value = useMemo(() => ({ form }), [form]);
  return (
    <FormRowContext.Provider value={value}>{children}</FormRowContext.Provider>
  );
};

export const useFormRowContext = () => {
  const context = useContext(FormRowContext);

  if (!context)
    throw new Error(
      'useFormRowContext must be used within a FormRowContextProvider',
    );

  return context;
};
